module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-590fccd242f3fc902d054eb0bfaf341d.webp";